import { createFileRoute, redirect, useRouter } from '@tanstack/react-router';
import { z } from 'zod';
import { TotpSetupPage } from '@/features/auth/totp-setup-page';
import { meQuery } from '@/lib/auth/session';
import { safeRedirect } from './login';

// ADR 0067: «Attiva la verifica in due passaggi» for an owner without TOTP on
// a host that requires it; without a session → the login, a temporary
// password still to replace → /password first, nothing to do → the app.
export const Route = createFileRoute('/totp-setup')({
  validateSearch: z.object({ redirect: z.string().optional() }),
  beforeLoad: async ({ context, search }) => {
    const user = await context.queryClient.ensureQueryData(meQuery).catch(() => null);
    if (!user) throw redirect({ to: '/login' });
    if (user.must_change_password) throw redirect({ to: '/password', search: { redirect: search.redirect } });
    if (!user.totp_setup_required) throw redirect({ href: safeRedirect(search.redirect) });
    return { user };
  },
  component: TotpSetup,
});

function TotpSetup() {
  const search = Route.useSearch();
  const { user } = Route.useRouteContext();
  const router = useRouter();
  return (
    <TotpSetupPage
      name={user.name.split(/\s+/)[0] ?? user.name}
      onDone={() => {
        void router.navigate({ href: safeRedirect(search.redirect), replace: true });
      }}
      onSignedOut={() => {
        void router.navigate({ to: '/login', replace: true });
      }}
    />
  );
}
